import axios from "axios";
import Cookies from "universal-cookie";

const cookies = new Cookies();

export const handleUserMetrics = async ({
  BACKEND_URL,
  entityId,
  campaignId,
  uniqueUserId,
  uniqueEmailId,
  externalUserId,
  questUserId,
  questUserToken,
  headers,
  GeneralFunctions,
}) => {
  try {
    if (
      externalUserId &&
      questUserId &&
      questUserToken &&
      externalUserId === uniqueUserId
    ) {
      const metricHeaders = {
        ...headers,
        userId: questUserId,
        token: questUserToken,
      };

      await axios.post(
        `${BACKEND_URL}api/entities/${entityId}/users/${questUserId}/metrics/onboarding-view`,
        { count: 1 },
        {
          params: { userId: questUserId, campaignId },
          headers: metricHeaders,
        }
      );
    } else if (uniqueUserId) {
      const body = {
        externalUserId: uniqueUserId,
        entityId: entityId,
        email: uniqueEmailId,
        ignoreMAU: true,
      };

      const response = await axios.post(
        `${BACKEND_URL}api/users/external/login`,
        body,
        { headers }
      );

      const { userId, token } = response.data;

      const date = new Date();
      date.setHours(date.getHours() + 12);

      cookies.set("externalUserId", uniqueUserId, { path: "/", expires: date });
      cookies.set("questUserId", userId, { path: "/", expires: date });
      cookies.set("questUserToken", token, { path: "/", expires: date });

      const metricHeaders = { ...headers, userId, token };
      await axios.post(
        `${BACKEND_URL}api/entities/${entityId}/users/${userId}/metrics/onboarding-view`,
        { count: 1 },
        {
          params: { userId, campaignId },
          headers: metricHeaders,
        }
      );
    }
  } catch (error) {
    console.error("Error handling user metrics:", error);
    GeneralFunctions?.captureSentryException(error);
  }
};

export const submitFormData = async (
  isV1Api,
  BACKEND_URL,
  entityId,
  campaignId,
  answer,
  selectedOptions,
  campaignVariationId,
  headers,
  formdata,
  isAccumulateAndSelf,
  GeneralFunctions
) => {
  try {
    const questUserId = cookies.get("questUserId");
    const questUserToken = cookies.get("questUserToken");

    const updatedHeaders = {
      ...headers,
      userId: questUserId || headers.userId,
      token: questUserToken || headers.token,
    };

    const combinedAnswer = { ...answer };
    Object.keys(selectedOptions).forEach((key) => {
      combinedAnswer[key] = selectedOptions[key];
    });

    if (!isV1Api) {
      const actions = Object.keys(combinedAnswer).map((key) => ({
        actionId: key,
        answers: Array.isArray(combinedAnswer[key])
          ? combinedAnswer[key]
          : [combinedAnswer[key]],
      }));

      const response = await axios.post(
        `${BACKEND_URL}api/v2/entities/${entityId}/campaigns/${campaignId}/verify`,
        { actions, campaignVariationId },
        { headers: updatedHeaders }
      );
      return response.data;
    } else {
      const criterias = Object.keys(combinedAnswer).map((key) => ({
        criteriaId: key,
        answer: Array.isArray(combinedAnswer[key])
          ? combinedAnswer[key]
          : [combinedAnswer[key]],
        question:
          formdata[formdata.findIndex((ele) => ele.criteriaId === key)]
            ?.question,
      }));

      const response = await axios.post(
        `${BACKEND_URL}api/entities/${entityId}/quests/${campaignId}/verify-all`,
        {
          criterias,
          userId: updatedHeaders.userId,
          isAccumulateAndSelf,
        },
        {
          params: { userId: updatedHeaders.userId },
          headers: updatedHeaders,
        }
      );
      return response.data;
    }
  } catch (error) {
    GeneralFunctions?.captureSentryException(error);
    throw error;
  }
};
